import { VIEWS, COLORS, SIZES, STATUSES } from '@core/js/components/common/Button/constants';

export { VIEWS, COLORS, SIZES, STATUSES };

export enum VARIANTS {
    regular = 'regular',
    rounded = 'rounded',
    underlined = 'underlined', // @theme
}
